// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../maintenance-plan/state/report';
import actions from '../../actions-list';

const updateMaintenancePlanReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_MAINTENANCE_PLAN_REPORT_SUCCESS]: updateMaintenancePlanReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateMaintenancePlanReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/reducers/report.js